import { updateMessages } from "@/plugins/i18n";
function siphonI18n(prefix = "zh-CN") {
  const result = {};
  Object.entries(
    import.meta.glob(["./**/*.js", "!./**/index.js"], { eager: true })
  ).map(([key, value]) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)[1];
    result[matched] = { ...result[matched], ...value.default };
  });
  return result[prefix];
}

export const localesConfigs = {
  zh: {
    ...siphonI18n("zh-CN")
  },
  en: {
    ...siphonI18n("en")
  }
};
let isInit = false;
export const initLocale = async () => {
  if (isInit) {
    return;
  }
  await updateMessages("zh", localesConfigs);
  isInit = true;
};
